var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreamoEngLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240.512 66.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#fca546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#fa9e42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#f48a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28036"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8",
    "data-name": "\\uADF8\\uB8F9 8",
    transform: "translate(-138.866 -153.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_6",
    "data-name": "\\uADF8\\uB8F9 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_48",
    "data-name": "\\uD328\\uC2A4 48",
    d: "M138.868,179.49a5.219,5.219,0,0,1,2.267-4.335l29.706-20.79s1.921-1.527,1.921.542v15.568a4.492,4.492,0,0,1-2.019,3.547l-28.82,20.149s-2.316,1.922-.394,3.942a4.22,4.22,0,0,1-2.414-4.04C139.065,190.92,138.868,179.49,138.868,179.49Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_49",
    "data-name": "\\uD328\\uC2A4 49",
    d: "M144.041,195.846a2.869,2.869,0,0,0-.049,3.991l28.672,19.853s2.414,1.134,2.217-1.773V203.63a3.7,3.7,0,0,0-1.823-3.054l-16.7-11.873s-1.379-.64-2.217,0Z",
    fill: "#1e1d35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7",
    "data-name": "\\uADF8\\uB8F9 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_50",
    "data-name": "\\uD328\\uC2A4 50",
    d: "M201.389,172.544h11.445a3.343,3.343,0,0,1,3.257,3.156v.8q0,1.719-2.157,2.877a3.554,3.554,0,0,1-1.319.279h-9.626a8.6,8.6,0,0,0-8.23,4.793,7.987,7.987,0,0,0-.44,2.538q0,3.9,4.434,6.252a9.568,9.568,0,0,0,3.775.839h9.747a3.68,3.68,0,0,1,3.756,2.656l.06.56v.8q0,1.659-2.058,2.816a2.491,2.491,0,0,1-1.078.28H201.03a14.373,14.373,0,0,1-9.228-3.774,13.971,13.971,0,0,1-3.135-4.116,13.057,13.057,0,0,1-1.539-5.874v-1.058q0-5.114,4.274-9.647A14.578,14.578,0,0,1,201.389,172.544Z",
    fill: "#5d5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_51",
    "data-name": "\\uD328\\uC2A4 51",
    d: "M223.464,172.544h17.059q3.654,0,6.731,3.435a8.751,8.751,0,0,1,1.819,4.913v1.179q0,3.5-3.477,6.552a10.185,10.185,0,0,1-3.376,1.578v.039q4.434,3.936,5.833,5.474a3.881,3.881,0,0,1,.619,1.977,3.607,3.607,0,0,1-2.516,3.375,3.491,3.491,0,0,1-.74.121h-.8q-1.4,0-3.694-2.477-.8-.66-9.068-8.291H227.3v7.331q0,2.339-2.7,3.377a2.725,2.725,0,0,1-.5.06h-.8q-1.818,0-2.976-2.2a2.9,2.9,0,0,1-.221-1.017V175.88q0-2.18,2.557-3.215A2.991,2.991,0,0,1,223.464,172.544Zm3.835,7.11v3.715H241.88v-3.715Z",
    fill: "#5d5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_52",
    "data-name": "\\uD328\\uC2A4 52",
    d: "M256.445,172.544H278.8a3.347,3.347,0,0,1,3.257,3.156v.8q0,1.719-2.158,2.877a3.546,3.546,0,0,1-1.319.279h-18.3v3.656h14.143a3.584,3.584,0,0,1,3.634,2.137,2.8,2.8,0,0,1,.281,1.138v.5q0,2.178-2.557,3.215a2.923,2.923,0,0,1-.8.119h-14.7v3.657h17.9a3.605,3.605,0,0,1,3.875,3.056v.959q0,1.659-2.058,2.816a2.494,2.494,0,0,1-1.078.28H256.285q-1.816,0-2.975-2.2a2.9,2.9,0,0,1-.221-1.017V175.88q0-2.18,2.557-3.215A2.985,2.985,0,0,1,256.445,172.544Z",
    fill: "#5d5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_53",
    "data-name": "\\uD328\\uC2A4 53",
    d: "M299.484,172.544h.618q2.219,0,3.576,3.535,10.248,20.193,10.547,20.993v1.079q0,1.816-2.4,2.915a3.863,3.863,0,0,1-.839.121h-.52q-2.238,0-3.615-3.655-7.05-13.944-7.151-14.023-7.89,15.859-8.329,16.5a3.462,3.462,0,0,1-2.436,1.179h-.5q-1.818,0-3-2.2a3.984,3.984,0,0,1-.179-1.017v-.44q0-.8,2.037-4.615l9.629-19.015A3.3,3.3,0,0,1,299.484,172.544Z",
    fill: "#5d5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_54",
    "data-name": "\\uD328\\uC2A4 54",
    d: "M320.79,172.544h.521q1.635,0,3.654,2.476.059,0,7.011,6.991,8.868-8.988,9.008-9.009a3.964,3.964,0,0,1,1.658-.458h.5a3.5,3.5,0,0,1,3.036,2.136,3.2,3.2,0,0,1,.219,1.02v22.391q0,1.659-2.057,2.816a2.494,2.494,0,0,1-1.078.28h-.8a3.324,3.324,0,0,1-2.737-1.759,3.84,3.84,0,0,1-.519-2.237v-12.3q-5.055,5.074-5.134,5.074a3.647,3.647,0,0,1-2.157.679q-1.9,0-3.995-2.538-3.235-3.276-3.3-3.276v12.8a3.47,3.47,0,0,1-2.8,3.5.817.817,0,0,1-.4.06h-.8a3.372,3.372,0,0,1-2.857-1.978,3.1,3.1,0,0,1-.339-1.358V175.82q0-2.039,2.517-3.155A3.794,3.794,0,0,1,320.79,172.544Z",
    fill: "#5d5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_55",
    "data-name": "\\uD328\\uC2A4 55",
    d: "M360.383,172.544h8.928a11.836,11.836,0,0,1,8.528,3.435,5.9,5.9,0,0,1,1.539,3.436v14.9q0,2.2-2.8,4.553a13.058,13.058,0,0,1-7.45,2.318h-8.368a12.23,12.23,0,0,1-8.29-2.977,5.971,5.971,0,0,1-2.057-4.174V179.694q0-3.535,4.833-6.032A14.055,14.055,0,0,1,360.383,172.544Zm-3.017,7.09V194.1h15.06V179.634Z",
    fill: "#5d5c5c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreamoEngLong);
export default __webpack_public_path__ + "static/media/creamo_eng_long.73b1462995f42a41f406ed311f5551c1.svg";
export { ForwardRef as ReactComponent };